import EventEmitter from "eventemitter3";

class ModalEmitter extends EventEmitter<{ open: never; close: never }> {}

export const modalEventEmitter = new ModalEmitter();
